import { render, staticRenderFns } from "./PageSatisfaction.vue?vue&type=template&id=3517d854&scoped=true&"
import script from "./PageSatisfaction.vue?vue&type=script&lang=js&"
export * from "./PageSatisfaction.vue?vue&type=script&lang=js&"
import style0 from "./PageSatisfaction.vue?vue&type=style&index=0&id=3517d854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3517d854",
  null
  
)

export default component.exports